var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364ZM17.3884 8.32828C17.6452 8.00332 17.59 7.53167 17.265 7.27482C16.9401 7.01797 16.4684 7.07319 16.2116 7.39816L9.93715 15.3366L9.92834 15.3479C9.91974 15.3592 9.90857 15.3683 9.89576 15.3745C9.88294 15.3806 9.86884 15.3836 9.85464 15.3831C9.84044 15.3827 9.82655 15.3789 9.81412 15.372C9.80169 15.3651 9.79109 15.3554 9.78319 15.3436L9.77304 15.3288L7.81304 12.5472C7.57445 12.2086 7.10655 12.1275 6.76795 12.3661C6.42935 12.6047 6.34828 13.0726 6.58686 13.4112L8.54253 16.1867C8.68269 16.3931 8.86952 16.5637 9.08793 16.6845C9.30938 16.807 9.55688 16.8749 9.80985 16.8825C10.0628 16.89 10.3139 16.8371 10.5423 16.728C10.7681 16.6201 10.9653 16.4604 11.1177 16.262L17.3884 8.32828Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFilled);
export default __webpack_public_path__ + "static/media/checkmark-filled.73f2a848d88d105459267e9f5510408d.svg";
export { ForwardRef as ReactComponent };